module.exports = __webpack_public_path__ + "static/media/tw6.9ffec002.png";